import { z } from "zod";

export const playncCompanyDataSchema = z.object({
  companyName: z.string(),
  companyStateCode: z.number(),
  iCafeId: z.string().optional(),
  isPrimary: z.boolean(),
  pcCafeAccount: z.string(),
  playncAccountId: z.string().uuid(),
  registeredAt: z.string(),
  sort: z.number(),
  updatedAt: z.string(),
});

export type PlayncCompanyDataType = z.infer<typeof playncCompanyDataSchema>;
